import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { ctaLabel, ctaDomain, performAdCta } from "@/lib/adCta";
import { AdLeadDialog } from "@/components/AdLeadDialog";

const VARIANTS = {
  strip: "px-4 py-2.5 bg-white/10 border-t border-white/10 backdrop-blur",
  card: "px-3 py-2 rounded-lg bg-white/10 border border-white/15",
};

// Dark CTA of a sponsored post inside the fullscreen viewers: `strip` = bottom of the PC stage
// (under the video, never over the native controls), `card` = mobile bottom block under the text.
// Impressions are counted by the column's AdCtaFooter — this only carries the action.
export const AdStageCta = ({ ad, author, variant = "strip", className = "", testId = "ad-stage-cta" }) => {
  const nav = useNavigate();
  const { openChat } = useApp();
  const [leadOpen, setLeadOpen] = useState(false);
  if (!ad) return null;
  const hasButton = ad.type && ad.type !== "none";
  if (!hasButton && !ad.headline && !ad.description) return null;
  return (
    <div className={`flex items-center gap-3 text-white ${VARIANTS[variant]} ${className}`} onClick={(e) => e.stopPropagation()} data-testid={`${testId}-${ad.id}`} data-variant={variant}>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] font-bold uppercase tracking-wide text-white/60">{ctaDomain(ad)}</div>
        {ad.headline && <div className="text-sm font-bold leading-snug truncate">{ad.headline}</div>}
        {ad.description && <div className="text-xs text-white/70 truncate">{ad.description}</div>}
      </div>
      {hasButton && (
        <button
          type="button"
          onClick={() => performAdCta(ad, { nav, openChat, author, openLead: () => setLeadOpen(true) })}
          className="pill pill-primary shrink-0 whitespace-nowrap"
          data-testid={`${testId}-btn-${ad.id}`}
        >
          {ctaLabel(ad)} <ChevronRight size={15} className="ml-0.5" />
        </button>
      )}
      <AdLeadDialog ad={ad} open={leadOpen} onOpenChange={setLeadOpen} />
    </div>
  );
};

export default AdStageCta;
